// deviceConfigure.js
// external libs
import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Helmet } from 'react-helmet-async'
import { Link, useNavigate } from 'react-router-dom'

import AppStore from '../../stores/AppStore'
import Footer from '../partials/Footer'
import NavigationBar from '../partials/NavigationBar'
import withAppStore from '../../util/withAppStore'

import styles from '../../../css/devicePage.module.css'

function DistributorToolsPage (props) {
  const navigate = useNavigate()

  const goTo = React.useCallback((x) => navigate(x), [navigate])
  const goBack = React.useCallback(() => {
    goTo('/home')
  }, [goTo])

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const {
    auth: {
      logout,
    },
    intl: {
      formatMessage,
    },
    route: {
      path: page,
    },
    level,
  } = props

  const ADMIN = formatMessage({
    id: 'customer.distributor.transferDevices',
    defaultMessage: 'Transfer Devices',
    description: 'Transfer Devices label',
  })

  const NEW_CUSTOMER = formatMessage({
    id: 'customer.distributor.newCustomer',
    defaultMessage: 'New Customer',
    description: 'New Customer label',
  })

  const EXISTING_CUSTOMER = formatMessage({
    id: 'customer.distributor.existingCustomer',
    defaultMessage: 'Existing Customer',
    description: 'Existing Customer label',
  })

  const {
    pages: {
      CustomerSettingsPage: title = ADMIN,
    },
  } = props

  const {
    id: customerID,
  } = AppStore.getCustomer()

  const navButton = (subPage, label) => (
    <div key={label} style={{ display: 'inline-block' }}>
      <Link
        to={subPage.match(/^[a-z]{1,25}/i) ? `/${customerID}/distributor/${subPage}` : subPage}
        className={styles.settingButtonCustomer}
      >
        <div className={`${styles.settingName} ${styles.settingNameCenter}`}>
          <h3>
            {label}
          </h3>
        </div>
      </Link>
    </div>
  )

  const navButtons = []

  if (level >= 20) {
    navButtons.push(navButton('newCustomer', NEW_CUSTOMER))
    navButtons.push(navButton('existingCustomer', EXISTING_CUSTOMER))
  }

  return (
    <div>
      <Helmet><title>{title}</title></Helmet>
      <NavigationBar
        backFunc={goBack}
        page={page}
        name={ADMIN}
        logOut={() => logout(navigate)}
      />
      <div className={styles.pageWidth}>
        <div className={styles.pageContainer}>
          {navButtons}
        </div>
      </div>
      <Footer />
    </div>
  )
}

DistributorToolsPage.propTypes = {
  auth: PropTypes.object,
  intl: PropTypes.object,
  route: PropTypes.object,
  pages: PropTypes.object,
  level: PropTypes.number,
}

export default withAppStore(injectIntl(DistributorToolsPage))
